<template>
  <v-container
    class="cmp-settings-general-settings dt-sidewindow submodule-root"
  >
    <div class="dt-tabs-container submodule-root">
      <glayout :tabs="generalSidewindowTabs" tabPanelColor="secondary">
        <gtab>
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount: territories && territories.length,
                    offset: NTOffsets.WithDBoxBottom,
                    max: 20
                  })
                "
                :title="$t('territory')"
              >
                <Territory
                  :territories="territories"
                  @add_new="onNewTerritoryAdd"
                  @delete="onTerritoryDelete"
                  @item_click="onTerritoryClick"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount: currencies && currencies.length,
                    offset: NTOffsets.WithDBoxBottom + 38,
                    max: 20
                  })
                "
                :title="$t('tab_title_currencies')"
              >
                <Currencies
                  :currencies="currencies"
                  @add_new="onNewCurrency"
                  @delete="onCurrencyDelete"
                  @update_exchr="onUpdateExchrate"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <!-- <gtab id="tasks">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    bookingSettingsData &&
                      bookingSettingsData.booking_task_templates &&
                      bookingSettingsData.booking_task_templates.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :title="$t('tab_title_tasks')"
              >
                <SettingsTaskTemplates
                  v-if="bookingSettingsData"
                  :settingsData="bookingSettingsData"
                  :externalTable="'booking'"
                />
                 @add_click="onTaskTemplateAddClick"
                  @delete="onTaskTemplateDeleted" 
              </gbox>
            </gcol>
          </grow>

        </gtab> -->
      </glayout>
    </div>

    <ModalContainer :modalKey="'addCurrency'" :width="'small'">
      <AddCurrency
        @added="onNewCurrencyAdded"
        @cancelled="onComponentModalClose"
      />
    </ModalContainer>

    <ModalContainer :modalKey="'editTerritory'" :width="'1000'">
      <AddTerritory
        @added="onNewTerritoryAdded"
        @cancelled="onComponentModalClose"
      />
    </ModalContainer>

    <ModalContainer :modalKey="'addTerritory'" :width="'1000'">
      <AddTerritory
        @added="onNewTerritoryAdded"
        @cancelled="onComponentModalClose"
      />
    </ModalContainer>
  </v-container>
</template>

<script>
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import * as ActionTypes from "../../store/types";
import { SettingsStoreNamespace as storeNS } from "../../store";
import { mapKeyToAction } from "../../../../store/global";
import { mapGetters } from "vuex";
import {
  createModalMixin,
  openModalRoute,
  closeModalRoute
} from "../../../../dt-plugins/modal/modal.mixin";
import ModalContainer from "@dtplugins/modal/modal-container";

import Territory from "./territory";
import Currencies from "./currencies";
import AddCurrency from "./add-currency";
import AddTerritory from "./add-territory";
import SettingsTaskTemplates from "../settings-plugins/settings-task-templates.vue";
export default {
  components: {
    ModalContainer,
    Territory,
    AddTerritory,
    Currencies,
    AddCurrency,
    SettingsTaskTemplates
  },
  mounted: function() {
    this[ActionTypes.GENERAL_DATA.FETCH.ALL]();
  },
  mixins: [
    createDTGridHost(),
    createModalMixin("addCurrency"),
    createModalMixin("addTerritory"),
    createModalMixin("editTerritory")
  ],
  computed: {
    ...mapGetters(storeNS, {
      territories: "territories",
      currencies: "currencies"
    }),
    generalSidewindowTabs: function() {
      return [
        {
          route: "overview",
          value: this.$t("overview")
        },
        // {
        //   route: "tasks",
        //   value: this.$t("tab_title_tasks"),
        // },
      ];
    }
  },
  methods: {
    ...mapKeyToAction(storeNS, [
      ActionTypes.GENERAL_DATA.FETCH.ALL,
      ActionTypes.UPDATE_EXCHANGE_RATES,
      ActionTypes.Currencies.SET.ALL,
      ActionTypes.Territories.SET.ALL,
      ActionTypes.Territories.DELETE.SINGLE,
      ActionTypes.Currencies.DELETE.SINGLE
    ]),
    onUpdateExchrate: function() {
      this[ActionTypes.UPDATE_EXCHANGE_RATES]();
    },
    onNewCurrency: function() {
      openModalRoute(this, "add_currency");
    },
    onComponentModalClose: function() {
      closeModalRoute(this, { territory_id: undefined });
    },
    onNewCurrencyAdded: function(payload) {
      this[ActionTypes.Currencies.SET.ALL](payload);
      this.onComponentModalClose();
    },
    onNewTerritoryAdd: function() {
      openModalRoute(this, "add_territory");
    },
    onNewTerritoryAdded: function(payload) {
      this[ActionTypes.Territories.SET.ALL](payload);
      this.onComponentModalClose();
    },
    onTerritoryDelete: function(item) {
      this[ActionTypes.Territories.DELETE.SINGLE](item.territory_id);
    },
    onCurrencyDelete: function(item) {
      this[ActionTypes.Currencies.DELETE.SINGLE](item.currency_id);
    },
    onTerritoryClick: function(item) {
      openModalRoute(this, "edit_territory", {
        territory_id: item.territory_id
      });
    }
    //MARK: Methods
  }
};
</script>

<style lang="scss">
.cmp-settings-general-settings {
  background: var(--bc-3, #f6f6f6);
  padding: 8px 32px;

  .dt-grid-layout {
    height: calc(100vh - 108px);
  }
}
</style>
